export const APP_CONFIG = {
  kind: "monitoring",
  devApiBaseUrl: "http://127.0.0.1:5000/api",
  devV2ApiBaseUrl: "http://127.0.0.1:5001/api",
  prodApiBaseUrl: "https://app.preditwins-monitoring.com/api",
  prodV2ApiBaseUrl: "https://app.preditwins-monitoring.com/api",
  storagePrefix: "",
};